import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommitteeApprovalType } from '../committee-approvals/committee-approval-type';
import { CommitteeItemsService } from '../committee-items/committee-items.service';
import Milestone from '../../interfaces/milestone';
import { UserPermissionsService } from 'src/app/services/user-permissions.service';

@Component({
    selector: 'app-committee-conditions',
    templateUrl: './committee-conditions.component.html',
    styleUrls: ['./committee-conditions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommitteeConditionsComponent implements OnInit {
  @Input('projectId') projectId: string;
  @Input('approvalType') approvalType: CommitteeApprovalType | undefined;
  @Input('milestoneId') milestoneId?: string;
  @Input('milestones') milestones: Milestone[] = [];
  @Input('isCompletedConditions') isCompletedConditions: boolean = false;
  @Input('title') title: string = 'CONDITIONS';
  @Input('headerColumns') headerColumns: string[] = [
    'cleared',
    'issue',
    'solution',
    'post_closing',
    'department',
    'milestone',
    'added_by',
    'added_on',
    'updated_by',
    'updated_on',
    'actions',
  ];
  @Input('isLegalNote') isLegalNote: boolean = false;
  @Input('milestone') milestone: Milestone;
  @Input('readOnly') readOnly: boolean;

  shouldExpand: boolean = true;
  public approvalTypeId: any;
  constructor(
    public itemsService: CommitteeItemsService,
    public permsService: UserPermissionsService
  ) {}

  ngOnInit(): void {
    this.permsService.getUserPermissions(
      'COMMITTEEAPPROVALTYPE',
      this.approvalType?.id + ''
    );
    if (this.isLegalNote) {
      this.headerColumns.splice(2, 1);
    }
    if (this.milestone?.name.toLowerCase()=='closed'){
      this.headerColumns.splice(3, 1)
    }
    if (this.approvalType?.id) {
      this.approvalTypeId = this.approvalType.id;
    }
  }
  addItem(): void {
    if (this.approvalType?.id) {
      this.approvalTypeId = this.approvalType.id;
      if (this.isLegalNote) {
        this.itemsService.addItem(this.projectId, this.approvalType.id, true, false);
      } else {
        this.itemsService.addItem(
          this.projectId,
          this.approvalType.id,
          false,
          true
        );
      }
    }
  }
}
